import type { SupplierVendorNexAliasGroup } from '../hooks/useGetSettings';

export function parseAliasListInput(raw: string): string[] {
    return Array.from(
        new Set(
            raw
                .split(/[,;\n]+/)
                .map((s) => s.trim())
                .filter(Boolean)
        )
    );
}

export function sortVendorNexAliasMappingsBySupplier(
    groups: SupplierVendorNexAliasGroup[]
): SupplierVendorNexAliasGroup[] {
    return [...groups].sort((a, b) =>
        a.supplierTitle.localeCompare(b.supplierTitle, undefined, { sensitivity: 'base' })
    );
}

export function cleanVendorNexAliasMappings(
    drafts: SupplierVendorNexAliasGroup[]
): SupplierVendorNexAliasGroup[] {
    return sortVendorNexAliasMappingsBySupplier(
        drafts
            .map((g) => ({
                supplierId: g.supplierId,
                supplierTitle: g.supplierTitle.trim(),
                invoiceTextAliases: Array.from(
                    new Set(g.invoiceTextAliases.map((a) => a.trim()).filter(Boolean))
                ),
                nexVendorMappings: (() => {
                    const byKey = new Map<string, { vendorId?: number; vendorName: string }>();
                    for (const m of g.nexVendorMappings) {
                        const vendorName = m.vendorName.trim();
                        if (!vendorName) continue;
                        const key = vendorName.toLowerCase();
                        const existing = byKey.get(key);
                        byKey.set(key, {
                            vendorName,
                            ...(m.vendorId != null && Number.isFinite(m.vendorId)
                                ? { vendorId: m.vendorId }
                                : existing?.vendorId != null
                                  ? { vendorId: existing.vendorId }
                                  : {}),
                        });
                    }
                    return Array.from(byKey.values());
                })(),
            }))
            .filter(
                (g) =>
                    g.supplierId &&
                    g.supplierTitle &&
                    (g.invoiceTextAliases.length > 0 || g.nexVendorMappings.length > 0)
            )
    );
}
